<template>
    <div class="ig-content card-content">
        <div class="dcard-header">
            <h4>Indice de Gestão</h4>
            <img v-if="!showBtn" class="ig-info" :src="infoSvg" width="50" height="50" alt="Info detalhes" @click="open" />
        </div>
        <div class="dcard-body">
            <div class="ig-radial">
                <IgSemiCircularChart v-if="igData?.igTotal" :datas="igData?.igTotal" />
            </div>
            <div class="ig-distribuicao">
                <IgDistribuicaoChart v-if="igData?.igDistribuicao" :showBtn="showBtn" :datas="igData?.igDistribuicao" />
            </div>
            <br style="clear:both;">
        </div>
        <div class="dcard-footer" style="margin-top: 0;position:relative">
            <router-link v-if="showBtn" to="/indice-de-gestao" class="ig-btn" @click="abrirIg">
                Abrir IG
            </router-link>
            <span v-if="igData?.dataDeExtracao" class="ig-legenda">Extração - {{ igData?.dataDeExtracao }}</span>
        </div>
    </div>
</template>

<script>
import IgSemiCircularChart from './chart/IgSemiCircularChart.vue';
import IgDistribuicaoChart from './chart/IgDistribuicaoChart.vue';

export default {
    name: 'DashboardIg',
    props: {
        showBtn: {
            type:Boolean,
            default: true
        },
        igData: {
            required: true
        },
        openDialog: {
            type: Function,
            required: false
        }
    },
    data() {
        return {
            infoSvg: require(`@/assets/info.svg`)
        };
    },
    methods: {
        open() {
          this.$emit('openDialog')
        },
        abrirIg() {
            this.trackingF360(this, 'IG','Acessar IG por dashboard');
        }
    },
    components: { 
        IgSemiCircularChart,
        IgDistribuicaoChart
    },
    mounted() {
        // se o card for mostrado na dashboard
        if(this.showBtn) {
            this.trackingF360(this, 'IG','Dashboard visualizado');
        }
    }
}
</script>
<style lang="scss">
.ig-content.card-content {
    padding: 15px;
    .dcard-header {
        h4 {
            font-size: 14px;
        }
    }
    .apexcharts-canvas {
        margin: 0 auto;
    }
    .ig-radial {
        position:relative;
    }
    .ig-radial:before {
        content: "";
        position: absolute;
        top: 10px;
        bottom: 38px;
        right: 8px;
        width: 2px;
        border-radius: 50%;
        background-color: #dedede;
    }
    .ig-radial, .ig-distribuicao {
        float: left;
        width:50%;
    }
    
    .ig-btn {
        color: #737373;
        font-size: 14px;
        padding: 4px;
        margin: 0 auto;
        max-width: 186px;
        text-align: center;
        border: 1px solid #ccc;
        border-radius: 4px;
        display: block;
        cursor: pointer;
        position: relative;
        top: -20px;
    }
    .ig-legenda {
        position: absolute;
        bottom: 23px;
        font-size: 12px;
        color: #737373;
    }
    .dcard-body {
        min-height: 185px;
    }
}
.ig-radial-chart {
    div {
        position:relative;
        z-index: 2;
        .apexcharts-canvas {
            position:absolute;
            top:20px;
        }
    }
    
}


</style>
<style lang="scss" scoped>
.grid-content .ig-content.card-content {
    padding: 5px 10px 0px;
    min-height: 228px !important;
}

</style>
